import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('life_benefits_set', '/life_benefits_sets', 'benefits_set')
const reducer = generator.generate()

export default reducer
